export default __webpack_public_path__ + "static/media/cpv_64_post-telecom.9981b916.svg";